/** @jsxImportSource @emotion/react */
import { Button, Message, useTheme } from "basis";
import { browser, isBrowserSupported } from "library/browser";
import queryString from "query-string";
import { FC, Fragment, useState } from "react";
import { useLocation } from "react-router-dom";
import { MaxWidthContainer } from "../MaxWidthContainer/MaxWidthContainer";

export const UnsupportedBrowserBanner: FC<{}> = () => {
  const theme = useTheme();
  const location = useLocation();
  const { debug } = queryString.parse(location?.search || "");
  const isDebug = debug === "true";
  const [showUnsupportedBrowserMessage, setShowUnsupportedBrowserMessage] =
    useState(!isBrowserSupported);

  if (!showUnsupportedBrowserMessage) {
    return null;
  }

  return (
    <div
      css={{
        backgroundColor: theme.colors.secondary.lightBlue.t25,
        padding: `${theme.space[4]} ${theme.space[4]}`,
        [theme.minMediaQueries.xs]: {
          padding: `${theme.space[4]} ${theme.space[10]}`,
        },
      }}
    >
      <MaxWidthContainer>
        <Message
          severity="info-or-minor"
          bg="secondary.lightBlue.t25"
          padding="0"
          callToAction={
            <Button
              variant="secondary"
              onClick={() => {
                setShowUnsupportedBrowserMessage(false);
              }}
            >
              Dismiss
            </Button>
          }
        >
          To get the best experience using the Latitude Service Centre, you’ll
          need to update your current browser to the latest version.
          {isDebug && (
            <Fragment>
              <br />
              You are using <strong>{browser.name}</strong> version{" "}
              <strong>{browser.versionNumber}</strong>.
            </Fragment>
          )}
        </Message>
      </MaxWidthContainer>
    </div>
  );
};
